import React, { useEffect, useState } from 'react';
import firebase_ from '../../../firebase/firebase';
import './QuestionList.css'
import { Avatar, Button, Divider, List, ListItem, MenuItem, Select } from '@material-ui/core'
import { Link } from 'react-router-dom'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

class QuestionList extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            questions: [],
            search: '',
            searchedQuestions: [],
            searched: false,
            questionIndex: [],
            sortBy: '',
            technologies: []
        }
    }

    async componentDidMount() {
        const db = firebase_.firestore()
        try {
            db.collection("Questions").get().then(async (querySnapshot) => {
                await querySnapshot.forEach(async (doc) => {

                    this.setState(prev => ({
                        questions: [...prev.questions, doc.data()],
                        questionIndex: [...prev.questionIndex, doc.id]
                    }))
                });
            });

        } catch (err) {
            console.log('error while fetching data', err);
        }
        await this.fetchTechnologies()
    }
    fetchQuestionsByTech(tech) {
        const db = firebase_.firestore()
        console.log('in sort');
        try {
            this.setState({ questions: [], questionIndex: [] })
            db.collection("Questions").get().then(async (querySnapshot) => {
                await querySnapshot.forEach(async (doc) => {
                    if (doc.data()['technology'] === tech) {
                        this.setState(prev => ({
                            questions: [...prev.questions, doc.data()],
                            questionIndex: [...prev.questionIndex, doc.id]
                        }))
                    }

                });
            });
            console.log('-->> ',this.state.questions);

        } catch (err) {
            console.log('error while fetching data', err);
        }
    }
    async fetchTechnologies() {
        const db = firebase_.firestore()

        try {
            await db.collection('Technologies').get()
                .then(response => {
                    response.forEach(element => {
                        this.setState(prevState => ({
                            technologies: [...prevState.technologies, element.data()]
                        }))
                    })
                })
        } catch (err) {
            console.log('error whiloe fetching technologies', err);
        }
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        })
    }
    handleSubmit = (e) => {
        e.preventDefault()
        var searchedData_ = []
        try {
            this.state.questions.forEach((element, index) => {
                if (element['question'].toString().includes(this.state.search)) {
                    console.log(element['question'], index, this.state.questions[index]);
                    searchedData_.push(this.state.questions[index])

                }


            })
            console.log('data ', searchedData_);
        } catch (err) {
            console.log('error in searching ', err);
        }
        finally {
            this.setState({
                searchedQuestions: searchedData_,
                searched: !this.state.searched
            })
        }

    }
    handleChangeSort = (e) => {
        this.setState({
            sortBy: e.target.value
        })
        this.fetchQuestionsByTech(e.target.value)

    }
    render() {
        return (
            <div>
                <div className="view-question-list">
                    <div style={{ display: 'flex' }}>
                        <Link to="/dashboard/addquestion" style={{ textDecoration: 'none' }}>
                            <Button className="question-add-btn">
                                Ask Question
                            </Button></Link>
                        <input id="search" type="search" name="search" placeholder="Search Question" onChange={this.handleChange} className="search-box-inpt" />
                        <Button className="search-btn" variant="outlined" onClick={this.handleSubmit}>Search</Button>

                    </div>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={this.state.sortBy}
                        onChange={this.handleChangeSort}
                        label="Age"
                    >
                        {this.state.technologies.map((element, index) => {
                            return (
                                <MenuItem value={element['name']}>
                                    {element['name']}
                                </MenuItem>
                            )
                        })}



                    </Select>
                    {this.state.searched ?
                        <List>
                            {this.state.searchedQuestions.map((element, index) => {
                                return (
                                    <Link to={`/dashboard/question/${this.state.questionIndex[index]}`} style={{ textDecoration: 'none' }}>
                                        <ListItem className="view-question-list-tem" button>
                                            <div style={{ display: "flex" }}>
                                                <HelpOutlineIcon style={{ marginTop: '2%' }} />
                                                <div>
                                                    <h2>{element['question']}</h2>
                                                    <div style={{ display: 'flex', justifyContent: 'stretch' }}>
                                                        <p>{element['askedBy'][0]['userName']}</p>

                                                        <p style={{ marginLeft: '2%' }}>#{element['technology']}</p>
                                                    </div>
                                                </div>
                                            </div>


                                        </ListItem>
                                        <hr />
                                    </Link>
                                )
                            })}
                        </List> :
                        <div>
                            {this.state.questions.map((element, index) => {
                                return (
                                    <Link to={`/dashboard/question/${this.state.questionIndex[index]}`} style={{ textDecoration: 'none' }}>
                                        <div className="view-question-list-tem" >

                                            <div style={{ display: "flex" }}>
                                                <HelpOutlineIcon style={{ marginTop: '2%' }} />
                                                <div>
                                                    <h2>{element['question']}</h2>
                                                    <div style={{ display: 'flex', justifyContent: 'stretch' }}>
                                                        <Avatar src={element['askedBy'][0]['profileImageUrl']}/>
                                                        <p style={{marginLeft:'5%'}}>{element['askedBy'][0]['userName']}</p>

                                                        <p style={{ marginLeft: '2%' }}>#{element['technology']}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Divider />
                                    </Link>
                                )
                            })}
                        </div>
                    }


                </div>
            </div>
        );
    }

}

export default QuestionList;